import React from 'react';

const DollarSign: React.FC<React.SVGProps<SVGSVGElement>> = ({ ...props }) => {
  return (
    <svg
      width="80"
      height="80"
      viewBox="0 0 80 80"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <rect width="80" height="80" fill="#00A868" />
      <path
        d="M49.9988 57.4961C52.6507 57.4961 55.1939 56.4425 57.0691 54.5674C58.9442 52.6922 59.9978 50.149 59.9978 47.4972C59.9978 44.8453 58.9442 42.3021 57.0691 40.4269C55.1939 38.5518 52.6507 37.4982 49.9988 37.4982H30.0143C28.6884 37.4982 27.4167 36.9715 26.4791 36.034C25.5415 35.0964 25.0149 33.8247 25.0149 32.4987C25.0149 31.1728 25.5415 29.9013 26.4791 28.9637C27.4167 28.0261 28.6884 27.4995 30.0143 27.4995H57.5135V22.5H30.0143C27.3625 22.5 24.8193 23.5533 22.9441 25.4285C21.0689 27.3037 20.0154 29.8469 20.0154 32.4987C20.0154 35.1506 21.0689 37.694 22.9441 39.5692C24.8193 41.4443 27.3625 42.4977 30.0143 42.4977H50.0122C51.3382 42.4977 52.6097 43.0243 53.5472 43.9619C54.4848 44.8995 55.0115 46.1712 55.0115 47.4972C55.0115 48.8231 54.4848 50.0948 53.5472 51.0324C52.6097 51.97 51.3382 52.4966 50.0122 52.4966H22.4997V57.4961H49.9988Z"
        fill="#20252A"
      />
      <path
        d="M57.5003 27.4999C58.8821 27.4999 60.0021 26.3799 60.0021 24.9981C60.0021 23.6163 58.8821 22.4961 57.5003 22.4961C56.1185 22.4961 54.9983 23.6163 54.9983 24.9981C54.9983 26.3799 56.1185 27.4999 57.5003 27.4999Z"
        fill="#20252A"
      />
      <path
        d="M22.4996 57.4999C23.8813 57.4999 25.0016 56.3797 25.0016 54.9979C25.0016 53.6161 23.8813 52.4961 22.4996 52.4961C21.1178 52.4961 19.9976 53.6161 19.9976 54.9979C19.9976 56.3797 21.1178 57.4999 22.4996 57.4999Z"
        fill="#20252A"
      />
      <path
        d="M39.9998 14.9979C41.3816 14.9979 42.5018 13.8777 42.5018 12.4959C42.5018 11.1141 41.3816 9.99414 39.9998 9.99414C38.6181 9.99414 37.498 11.1141 37.498 12.4959C37.498 13.8777 38.6181 14.9979 39.9998 14.9979Z"
        fill="white"
      />
      <path
        d="M39.9998 69.996C41.3816 69.996 42.5018 68.8758 42.5018 67.494C42.5018 66.1122 41.3816 64.9922 39.9998 64.9922C38.6181 64.9922 37.498 66.1122 37.498 67.494C37.498 68.8758 38.6181 69.996 39.9998 69.996Z"
        fill="white"
      />
      <path d="M42.4975 12.4961H37.498V67.4944H42.4975V12.4961Z" fill="white" />
    </svg>
  );
};

export default DollarSign;
